(async () => {
    if (!customElements.get("product-custom-swatch")) {
        class ProductCustomSwatch extends HTMLElement {
            constructor() {
                super();
                this.swiperElement = this.querySelectorAll("[data-swiper-product-variant]");
                this.swiperOptions = {
                    loop: false,
                    autoplay: false,
                    slidesPerView: 4.5,
                    direction: "horizontal",
                    observer: false,
                    resizeEvent: "auto",
                    breakpoints: {
                        320: {
                            slidesPerView: 2.5,
                            spaceBetween: 10
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 10
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 15
                        },
                        1440: {
                            slidesPerView: 3,
                            spaceBetween: 15
                        }
                    }
                };
                if (this && this.dataset && this.dataset.options) {
                    const jsonOptions = JSON.parse(this.dataset.options);
                    if (jsonOptions) {
                        this.swiperOptions = {
                            ...this.swiperOptions,
                            ...jsonOptions
                        }
                    }
                }
                if (Shopify.designMode && this.swiperInstance) {
                    window.addEventListener("shopify:section:load", (() => {
                        this.swiperInstance.update()
                    }))
                }
                this.init()
            }
            init() {
                this.swiperElement.forEach((swiperEle => {
                    this.swiperInstance = new Swiper(swiperEle, this.swiperOptions)
                }))
            }
        }
        window.ProductCustomSwatch = ProductCustomSwatch;
        customElements.define("product-custom-swatch", ProductCustomSwatch)
    }
})();
//# sourceMappingURL=product-variant.js.map